import axios from 'axios';
const apiHost = process.env.VUE_APP_UMBRELLA_BACKEND || '';

class ApiRequest {
  constructor(endpint) {
    this.endpoint = endpint;
  }

  async getAll() {
    try {
      console.time(`get ${this.endpoint}`);

      const result = await axios.get(`${apiHost}/api/v1/${this.endpoint}`, {
        headers: {
          // Authorization: token,
          'Referrer-Police': 'strict-origin-when-cross-origin',
        },
      });

      console.timeEnd(`get ${this.endpoint}`);

      return result.data;
    } catch (error) {
      console.error(error);
    }

    return [];
  }

  async create(data) {
    try {
      console.time(`create ${this.endpoint}`);

      const result = await axios.post(`${apiHost}/api/v1/${this.endpoint}`, data, {
        headers: {
          // Authorization: token,
          'Referrer-Police': 'strict-origin-when-cross-origin',
        },
      });

      console.timeEnd(`create ${this.endpoint}`);

      return result.data;
    } catch (error) {
      console.error(error);
    }

    return [];
  }

  async update(data) {
    try {
      console.time(`update ${this.endpoint}`);

      const result = await axios.patch(`${apiHost}/api/v1/${this.endpoint}`, data, {
        headers: {
          // Authorization: token,
          'Referrer-Police': 'strict-origin-when-cross-origin',
        },
      });

      console.timeEnd(`update ${this.endpoint}`);

      return result.data;
    } catch (error) {
      console.error(error);
    }

    return [];
  }

  /* eslint-disable no-alert, class-methods-use-this */
  async get(endpoint) {
    try {
      console.time(`get ${endpoint}`);
      const result = await axios.get(`${apiHost}/api/v1/${endpoint}`, {
        headers: {
          // Authorization: token,
          'Referrer-Police': 'strict-origin-when-cross-origin',
        },
      });

      console.timeEnd(`get ${endpoint}`);

      return result.data;
    } catch (error) {
      console.error(error);
    }

    return [];
  }
}

export default ApiRequest;
